export const GlobalFooter = {
  baseStyle: {},
  defaultProps: {},
  variants: {},
};
